import agreementsPageRoute from './AgreementsPage/route';
import annualStatementsPageRoute from './AnnualStatementsPage/route';
import deliveryApprovalsPageRoute from './DeliveryApprovalsPage/route';
import expiringAgreementsPageRoute from './ExpiringAgreementsPage/route';
import infoPageRoute from './Info/route';
import newAgreementPageRoute from './NewAgreementPage/route';
import organizationPageRoute from './Organization/route';
import searchPageRoute from './SearchPage/route';

export const routes = [
  annualStatementsPageRoute,
  agreementsPageRoute,
  newAgreementPageRoute,
  deliveryApprovalsPageRoute,
  infoPageRoute,
  expiringAgreementsPageRoute,
  organizationPageRoute,
  searchPageRoute,
] as const;

export const allPaths = routes.map((route) => route.path);

export default routes;
